export default __webpack_public_path__ + "static/media/bg_waves.38c8cab3.svg";